import { useState } from 'react';
import { Button, Switch, Form } from 'antd';
import ModalInContainer from './components/ModalInContainer';
import { useTranslation } from 'react-i18next';

const SettingPreference = ({ platform, previewLang, values, detail }) => {
    const [form] = Form.useForm();
    const [isChange, setIsChange] = useState(false);
    const [cookieDetail, setCookieDetail] = useState([]);
    const { t } = useTranslation();

    const Layout = (platform) => {
        switch (platform) {
            case 'Desktop':
                return {
                    isMobile: false,
                    modalWidth: 600,
                    layoutDevice: 'inset-x-3 top-12 bottom-3',
                    paddingContent: 'px-4',
                    positionTitle: '',
                    buttonWidth: 'w-44',
                    positionTitleDetail: '',
                    spaceTitleDetail: '',
                };
            case 'Tablet':
                return {
                    isMobile: false,
                    modalWidth: 450,
                    layoutDevice: 'inset-x-3 top-4 bottom-10',
                    paddingContent: 'px-4',
                    positionTitle: '',
                    buttonWidth: 'w-44',
                    positionTitleDetail: '',
                    spaceTitleDetail: '',
                };
            case 'Mobile':
                return {
                    isMobile: true,
                    modalWidth: 320,
                    layoutDevice: 'inset-x-3 top-4 bottom-3',
                    paddingContent: 'px-4',
                    positionTitle: 'text-center',
                    buttonWidth: 'w-[100%]',
                    positionTitleDetail: 'justify-between',
                    spaceTitleDetail: 'ml-[-2rem]',
                };
            default:
                return {
                    isMobile: false,
                    modalWidth: 600,
                    paddingContent: 'px-4',
                    positionTitle: '',
                    buttonWidth: 'w-44',
                    positionTitleDetail: '',
                    spaceTitleDetail: '',
                };
        }
    };

    const getButtonStyles = () => {
        const buttonThemeColor =
            values?.customizeStylePreference?.buttonThemeColor;
        return {
            className: `font-medium h-12 px-2 ${
                Layout(platform).buttonWidth
            } bg-[${buttonThemeColor}] border-[${buttonThemeColor}] hover:opacity-80 hover:bg-[${buttonThemeColor}] hover:border-[${buttonThemeColor}] focus:bg-[${buttonThemeColor}] focus:border-[${buttonThemeColor}]`,
            style: {
                color: values?.customizeStylePreference?.button?.color,
                fontSize: values?.customizeStylePreference?.button?.fontSize,
                background: buttonThemeColor,
                border: `1px solid ${buttonThemeColor}`,
            },
        };
    };

    console.log(cookieDetail);

    return (
        <div
            className={`${values?.customizeStylePreference?.fontFamily?.toLowerCase()}`}
        >
            <ModalInContainer
                id="modal-preferent-task"
                width={Layout(platform).modalWidth}
                className={`small-scrollbar ${Layout(platform).layoutDevice}`}
                open={true}
                isMobile={Layout(platform).isMobile}
                values={values}
                title={
                    !isChange ? (
                        <div
                            className={`mb-4 ${Layout(platform).positionTitle}`}
                            style={{ borderBottom: '1px solid #DBDBDB' }}
                        >
                            <div className="pb-2">
                                <span
                                    className="font-medium mb-2"
                                    style={{
                                        color: values?.customizeStylePreference
                                            ?.header?.color,
                                        fontSize:
                                            values?.customizeStylePreference
                                                ?.header?.fontSize,
                                    }}
                                >
                                    {t('Setting Preference')}
                                </span>
                            </div>
                        </div>
                    ) : (
                        <div
                            className="mb-4"
                            style={{ borderBottom: '1px solid #DBDBDB' }}
                        >
                            <div
                                className={`flex items-center ${
                                    Layout(platform).positionTitleDetail
                                }`}
                                style={{
                                    color: values?.customizeStylePreference
                                        ?.header?.color,
                                    fontSize:
                                        values?.customizeStylePreference?.header
                                            ?.fontSize,
                                }}
                            >
                                <button
                                    type="button"
                                    className="cursor-pointer mr-3"
                                    onClick={() => {
                                        setIsChange(false);
                                        setCookieDetail([]);
                                    }}
                                >
                                    <svg
                                        width="22"
                                        height="23"
                                        viewBox="0 0 22 23"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M19.2506 10.5836H5.88009L10.732 5.73171L9.43584 4.43555L2.37109 11.5003L9.43584 18.565L10.732 17.2689L5.88009 12.417H19.2506V10.5836Z"
                                            fill={
                                                values?.customizeStylePreference
                                                    ?.buttonThemeColor
                                            }
                                        />
                                    </svg>
                                </button>
                                <div
                                    className={`font-medium mb-2 ${
                                        Layout(platform).spaceTitleDetail
                                    }`}
                                >
                                    {t('COOKIE.PrivacyPreference')}
                                </div>
                                <div></div>
                            </div>
                        </div>
                    )
                }
                style={{
                    background:
                        values?.customizeStylePreference?.backgroundThemeColor,
                }}
            >
                {!isChange && (
                    <div
                        className={`${
                            Layout(platform).paddingContent
                        } flex flex-col space-y-2 mt-2 overflow-auto h-[33rem]`}
                    >
                        {detail?.map((e) => (
                            <div
                                key={e.cookieId}
                                style={{
                                    background:
                                        values?.customizeStylePreference
                                            ?.backgroundCardColor,
                                }}
                                className="rounded-[2.6px] p-4"
                            >
                                <div
                                    className={
                                        platform === 'Mobile'
                                            ? 'flex justify-between'
                                            : ''
                                    }
                                >
                                    <div
                                        className="font-medium"
                                        style={{
                                            color: values
                                                ?.customizeStylePreference
                                                ?.cookieCategoryName?.color,
                                            fontSize:
                                                values?.customizeStylePreference
                                                    ?.cookieCategoryName
                                                    ?.fontSize,
                                        }}
                                    >
                                        {previewLang === 'en'
                                            ? e.cookieCategory
                                            : e.cookieCategoryTh}
                                    </div>
                                    <div hidden={platform !== 'Mobile'}>
                                        <Switch />
                                    </div>
                                </div>
                                {e.cookieCategory === 'Necessary' ? (
                                    <div
                                        style={{
                                            color: values
                                                ?.customizeStylePreference
                                                ?.cookieCategoryDescription
                                                ?.color,
                                            fontSize:
                                                values?.customizeStylePreference
                                                    ?.cookieCategoryDescription
                                                    ?.fontSize,
                                            width: '90%',
                                        }}
                                    >
                                        {previewLang === 'en'
                                            ? e.cookieDetail
                                            : e.cookieDetailTh}
                                        {e.cookieDetailList?.length > 0 && (
                                            <button
                                                type="button"
                                                className={`cursor-pointer underline hover:opacity-80 hover:text-[${values?.customizeStylePreference?.link?.color}] hover:underline`}
                                                style={{
                                                    color: values
                                                        ?.customizeStylePreference
                                                        ?.link?.color,
                                                    fontSize:
                                                        values
                                                            ?.customizeStylePreference
                                                            ?.link?.fontSize,
                                                }}
                                                onClick={() => {
                                                    setIsChange(true);
                                                    setCookieDetail(
                                                        e.cookieDetailList
                                                    );
                                                }}
                                            >
                                                {previewLang === 'en'
                                                    ? `Cookie Detail`
                                                    : 'คุกกี้ที่เกี่ยวข้อง'}
                                            </button>
                                        )}
                                    </div>
                                ) : (
                                    <div className="flex space-x-2 item-center">
                                        <div
                                            style={{
                                                color: values
                                                    ?.customizeStylePreference
                                                    ?.cookieCategoryDescription
                                                    ?.color,
                                                fontSize:
                                                    values
                                                        ?.customizeStylePreference
                                                        ?.cookieCategoryDescription
                                                        ?.fontSize,
                                            }}
                                        >
                                            {previewLang === 'en'
                                                ? e.cookieDetail
                                                : e.cookieDetailTh}
                                            {e.cookieDetailList?.length > 0 && (
                                                <button
                                                    type="button"
                                                    className={`cursor-pointer underline hover:opacity-80 hover:text-[${values?.customizeStylePreference?.link?.color}] hover:underline`}
                                                    style={{
                                                        color: values
                                                            ?.customizeStylePreference
                                                            ?.link?.color,
                                                        fontSize:
                                                            values
                                                                ?.customizeStylePreference
                                                                ?.link
                                                                ?.fontSize,
                                                    }}
                                                    onClick={() => {
                                                        setIsChange(true);
                                                        setCookieDetail(
                                                            e.cookieDetailList
                                                        );
                                                    }}
                                                >
                                                    {previewLang === 'en'
                                                        ? `Cookie Detail`
                                                        : 'คุกกี้ที่เกี่ยวข้อง'}
                                                </button>
                                            )}
                                        </div>
                                        <div
                                            className="w-14"
                                            hidden={platform === 'Mobile'}
                                        >
                                            <Form.Item
                                                name={e.cookieId}
                                                valuePropName="checked"
                                            >
                                                <Switch />
                                            </Form.Item>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {isChange && (
                    <div
                        className={`${
                            Layout(platform).paddingContent
                        } overflow-auto h-[33rem] mb-4`}
                        style={{ borderBottom: '1px solid #DBDBDB' }}
                    >
                        {cookieDetail?.map((e) => (
                            <div
                                key={e.category}
                                style={{
                                    background:
                                        values?.customizeStylePreference
                                            ?.backgroundCardColor,
                                }}
                                className="bg-[#F3F9FF] rounded-[2.6px] p-4 mb-4"
                            >
                                <div
                                    style={{
                                        color: values?.customizeStylePreference
                                            ?.cookieCategoryDescription?.color,
                                        fontSize:
                                            values?.customizeStylePreference
                                                ?.cookieCategoryDescription
                                                ?.fontSize,
                                    }}
                                    className="grid grid-cols-6 gap-2 text-[14px]"
                                >
                                    <div className="col-span-2 font-semibold">
                                        {t('Category')} :
                                    </div>
                                    <div className="col-span-4">
                                        {e.category || '-'}
                                    </div>
                                    <div className="col-span-2 font-semibold">
                                        {t('COOKIE.Description')} :
                                    </div>
                                    <div className="col-span-4">
                                        {e.description || '-'}
                                    </div>
                                    <div className="col-span-2 font-semibold">
                                        {t('COOKIE.Duration')} :
                                    </div>
                                    <div className="col-span-4">
                                        {e.duration || '-'}
                                    </div>
                                    <div className="col-span-2 font-semibold">
                                        {t('COOKIE.Host')} :
                                    </div>
                                    <div className="col-span-4">
                                        {e.host || '-'}
                                    </div>
                                    <div className="col-span-2 font-semibold">
                                        {t('Name')} :
                                    </div>
                                    <div className="col-span-4">
                                        {e.name || '-'}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                <div className="space-x-4 items-center text-center mt-6 mb-2 px-4">
                    <Button size="large" type="primary" {...getButtonStyles()}>
                        {previewLang === 'en' ? 'Confirm' : 'ยืนยัน'}
                    </Button>
                </div>
            </ModalInContainer>
        </div>
    );
};

export default SettingPreference;
